import React from 'react';
import { Typography } from "@material-ui/core"
import useRkSchnelltarifierung from '../../../../consumer/rk/useRkSchnelltarifierung';
import ErrorMessage from '../../../cmp/message/ErrorMessage';
import useWizardFormCtx from '../ctx-provider/useWizardFormCtx';
import FormBo from '../step-ihr-tier/FormBo';
import AppTranslation from '../../../../app/AppTranslation';
import PageContentArea from '../step/PageContentArea';
import useCssMediaQuery from '../../../useCssMediaQuery';
import ProduktDevDesktop from "./produkt/ProduktDevDesktop";
import ProduktDevMobile from "./produkt/ProduktDevMobile";
import Form from './Form';

const Page: React.FC = () => {
    const { error, loading } = useRkSchnelltarifierung();
    const { wizardFormBo } = useWizardFormCtx();
    const hunde = FormBo.exportHunde(wizardFormBo.ihrTier);
    const titelText = AppTranslation.getProduktTitelAngebot(hunde);
    const cssMediaQuery = useCssMediaQuery();

    return (
        <>

            <PageContentArea nextBtnDisabled={error || loading} nextBtnVisible={cssMediaQuery.desktopVersion}>
                <div style={{ textAlign: 'center' }}>
                    <Typography variant='h1' color='textPrimary'>{titelText}</Typography>
                    <Typography variant='h6' color='textPrimary' style={{ marginTop: 10 }}>
                        Wir benötigen nur noch ein paar Angaben zu Ihrem gewünschten Versicherungsumfang und den präferierten Zahlungsmodalitäten.
                    </Typography>
                </div>
                <div style={{ marginTop: 40 }}>
                    <Form disabled={loading} />
                    {error && <div style={{ marginTop: 20 }}> <ErrorMessage /> </div>}
                </div>

                {cssMediaQuery.desktopVersion ?
                    <div style={{ marginTop: 30 }}>
                        <ProduktDevDesktop loading={loading} />
                    </div>
                    :
                    <div style={{ marginTop: 60 }}>
                        <ProduktDevMobile loading={loading} />
                    </div>
                }
            </PageContentArea >
        </>)
};

export default Page;

